import { Grid, Typography } from '@mui/material';
import ContentTitle from '../../layout/ContentTitle/ContentTitle';
import Observer from '../../shared/Observer/Observer';
import ServiceCard from '../ServiceCard/ServiceCard';
import { PAGE } from '../../../constants/page';
import ArrowButton from '../../ui/ArrowButton/ArrowButton';

interface Props {
  children?: React.ReactElement<unknown>;
}

const texts1 = [
  "自由な発想で新たな領域に踏み込み、",
  "ITを通して未来と新たな価値を創造し、",
  "社会に貢献をしていきます。",
]

const texts2 = [
  "IoT時代に対応した設計や、システム全体の効率化を実現するカスタマイズ開発ができます。",
  "オープン系を中心に、さまざまなシステム開発を行っており、車載システムや、IoT機器など",
  "製造業における幅広い分野の組込みソフトウェア開発を手掛けています。",
]

const services = [
  {
    image: "/assets/images/service_system.jpg",
    title: "システム開発",
    summary: "車載機器や計測機器などの分野で高品質かつ信頼性の高いハードウェアソリューションを提供します。",
    url: PAGE.SYSTEM.PATH
  },
  {
    image: "/assets/images/service_software.jpg",
    title: "ソフトウェア開発",
    summary: "計測機器との連携を含むシステムアーキテクチャ設計から、クラウド連携、アプリケーション開発まで、最適なソリューションを提供します。",
    url: PAGE.SOFTWARE.PATH
  }
]

export default function ServiceSection(props: Props) {
  return (
    <>
      <Grid container>
        <Grid size={12}>
          <Observer>
            <ContentTitle title={PAGE.SERVICE.NAME} subTitle={PAGE.SERVICE.TEXT} />
          </Observer>
        </Grid>

        <Grid size={12}
          sx={(theme) => ({
            [theme.breakpoints.up('xs')]: {
              marginTop: '3rem',
              marginBottom: '3rem'
            },
            [theme.breakpoints.up('md')]: {
              marginTop: '4rem',
              marginBottom: '4rem'
            },
            [theme.breakpoints.up('lg')]: {
              marginTop: '5rem',
              marginBottom: '5rem'
            },
          })}
        >
          {texts1.map((t, index) => {
            return (
              <Observer key={index} timeout={(index + 1) * 100}>
                <Typography
                  key={index}
                  variant="body1"
                  sx={(theme) => ({
                    [theme.breakpoints.up('xs')]: {
                      fontSize: '1.25rem',
                    },
                    [theme.breakpoints.up('sm')]: {
                      fontSize: '1.5rem',
                    },
                    [theme.breakpoints.up('md')]: {
                      fontSize: '1.75rem',
                    },
                    [theme.breakpoints.up('lg')]: {
                      fontSize: '2rem',
                    },
                  })}
                >
                  {t}
                </Typography>
              </Observer>
            )
          })}
        </Grid>

        <Grid size={12} sx={{ padding: '2rem' }}>
          {texts2.map((t, index) => {
            return (
              <Observer key={index} timeout={(index + 1) * 100}>
                <Typography
                  key={index}
                  variant="body2"
                  sx={(theme) => ({
                    fontSize: '1.25rem',
                    [theme.breakpoints.up('md')]: {
                      fontSize: '1.5rem',
                    },
                  })}
                >
                  {t}
                </Typography>
              </Observer>
            )
          })}
        </Grid>

        <Grid size={12}>
          <Grid container spacing={2}>
            {services.map((service, index) => {
              return (
                <Grid key={index} size={{ xs: 12, sm: 12, md: 6 }}  sx={{ padding: '0.5rem 0' }}>
                  <Observer timeout={(index + 1) * 500}>
                    <ServiceCard service={service} />
                  </Observer>
                </Grid>
              )
            })}
          </Grid>
        </Grid>
      </Grid>

      <Grid size={{ sm: 12, lg: 12 }} sx={{ textAlign: 'right', padding: '1rem' }}>
        <Observer timeout={3 * 500}>
          <ArrowButton label="MORE" href={PAGE.SERVICE.PATH} />
        </Observer>
      </Grid>
    </>
  )
}